import * as React from 'react';
import Project from 'src/entities/Project';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Person from 'src/entities/Person';
import Investment from 'src/entities/Investment';
import '../Modals.css';
import InvestmentFunnelHeaderComponent from './partials/InvestmentFunnelHeader.component';
import { Link } from 'react-router-dom';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';

export interface InvestmentFunnelComponentProps {
  project: Project;
  showWarning: boolean;
  modalRef?: Modal;
  person: Person;
  investment: Investment;
  reinvestment: boolean;
  next: () => void;
  previous: () => void;
  handleChange: () => void;
}

class InvestmentFunnelComponent extends React.PureComponent<InvestmentFunnelComponentProps> {

 // TODO
 /* private dataTemplateNoCredit: string = `
    <div className="popover popover-message" role="tooltip">
      <div className="arrow"/>
      <div className="popover-content"/>
    </div>
  `;*/

  public render(): React.ReactNode {
    const investedValue = NumberFormater
      .euros(this.props.investment.quantityTickets * this.props.project.ticketValue * 1);

    const feeValue = NumberFormater
      .euros(this.props.investment.quantityTickets * this.props.project.ticketValue *
        (this.props.investment.fees * 0.01) * 1.21);

    const totalValue = NumberFormater
      .euros(this.props.investment.quantityTickets * this.props.project.ticketValue *
        (1.0 + (this.props.investment.fees * 0.01) * 1.21));

    let equity = (this.props.investment.quantityTickets * this.props.project.sharePercentage).toString();

    equity = parseFloat(equity).toLocaleString('es-ES', {minimumFractionDigits: 4});

    return (
      <div className="modal-content investment-funnel-modal">
        <InvestmentFunnelHeaderComponent
          logo={this.props.project.company.logo}
          modalRef={this.props.modalRef}
        />
        <div className="modal-body">
          <h6 className="f-s-18">
            Resumen de la inversión:
          </h6>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-sm-6">
              <div className="icon-content pledge">
                <img
                  alt="user"
                  className="icon"
                  src="/img/small-user.png"
                />
                <p className="inline-block f-s-16">
                  Perfil de inversión:
                  <br/>
                  <strong>
                    {this.props.person.displayName}
                  </strong>
                </p>
              </div>
              <hr className="dashed"/>
              <div className="icon-content pledge">
                <img
                  alt="wallet"
                  className="icon"
                  src="/img/small-wallet.png"
                />
                <p className="inline-block f-s-16">
                  Tickets comprometidos:<br/>
                  <strong>{this.props.investment.quantityTickets}</strong>
                </p>
              </div>
              <hr className="dashed"/>
              <div className="icon-content pledge">
                <img
                  alt="Participation"
                  className="icon"
                  src="/img/small-participation.png"
                />
                <p className="inline-block f-s-16">
                  Participación en la empresa:&nbsp;
                  {/*TODO*/}
                  {/*<span
                    className="no-credit no-credit-green"
                    data-container="body"
                    data-template={this.dataTemplateNoCredit}
                    data-html="true"
                    data-trigger="hover"
                    data-toggle="popover"
                    data-placement="bottom"
                    data-content="Lorem ipsum dolor sit amet, consectetur adipiscg."
                  />*/}
                  <br/>
                  <strong>
                    {equity} %
                  </strong>
                </p>
              </div>
              <hr className="dashed"/>
            </div>
            <div className="col-sm-6">
              <div className="icon-content pledge">
                <img

                  className="icon"
                  src="/img/small-bag.png"
                />
                <p className="inline-block f-s-16">
                  Representante de TCA:<br/>
                  <strong>{this.props.investment.tcaRepresentative ? 'Sí' : 'No'}</strong>
                </p>
              </div>
              <hr className="dashed"/>

              <div className="icon-content pledge">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/small-euro.png"
                />
                <p className="inline-block f-s-16">
                  Capital comprometido:<br/>
                  <strong>
                    {investedValue}
                  </strong>
                </p>
              </div>
              <hr className="dashed"/>

              <div className="icon-content pledge">
                <img
                  alt="user"
                  className="icon"
                  src="/img/small-percent.png"
                />
                <p className="inline-block f-s-16">
                  Corretaje {this.props.investment.fees}% + IVA:&nbsp;
                  {/*TODO*/}
                  {/*<span
                    className="no-credit no-credit-green"
                    data-container="body"
                    data-template={this.dataTemplateNoCredit}
                    data-html="true"
                    data-trigger="hover"
                    data-toggle="popover"
                    data-placement="bottom"
                    data-content="Lorem ipsum dolor sit amet, consectetur adipiscg."
                  />*/}
                  <br/>
                  <strong>
                    {feeValue}
                  </strong>
                  <br/>
                </p>
              </div>
              <hr className="dashed"/>
            </div>
          </div>
          <div className="gap-20"/>
          <p className="f-s-26">
            Total:&nbsp;
            <strong>
              {totalValue}
            </strong>
          </p>
          <div className="gap-20"/>
          {this.props.reinvestment ?
            null :
            <div className="checkbox">
              <input
                id="checkbox1"
                type="checkbox"
                checked={this.props.investment.termsAndConditions}
                onClick={this.props.handleChange}
              />
              <label
                htmlFor="checkbox1"
                className="c-primary-dark"
              >
                Sí, acepto los&nbsp;
                <Link
                  to="/terminos-y-condiciones"
                  target="_blank"
                  className="underline"
                >
                  términos de la inversión
                </Link>
                &nbsp;y me comprometo a realizar la inversión.
              </label>
            </div>
          }
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-6">
              <button
                className="btn btn-info margin-r-10 btn-lg"
                onClick={this.props.previous}
              >
                Atrás
              </button>
            </div>
            <div className="col-md-6">
              {this.props.reinvestment ?
                <button
                  className="btn btn-secondary btn-lg"
                  onClick={this.props.next}
                >
                  Invertir
                </button>
                : <button
                  className="btn btn-secondary btn-lg"
                  onClick={this.props.next}
                >
                  Siguiente
                </button>
              }
              <div className="gap-20"/>
              {this.props.showWarning ?
                <div>
                  <span className="arrow-right-primary-dark"/>
                  Debes aceptar los terminos de la inversión
                </div> :
                null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InvestmentFunnelComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/InvestmentFunnel.component.tsx